export default __webpack_public_path__ + "static/media/location_flag_hovered.6c0beb2d.png";